import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "team-invite-pagee" }

import {ref, onMounted} from 'vue';
import AcceptMember from "./components/AcceptMember.vue";
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const acceptDialogRef=ref()

function openAcceptDialog(data = {}) {
  const inviteId=route.query?.inviteId;
  acceptDialogRef.value?.openDialog({inviteId});
}

onMounted(()=>{
  openAcceptDialog();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AcceptMember, {
      ref_key: "acceptDialogRef",
      ref: acceptDialogRef
    }, null, 512)
  ]))
}
}

})